export default __webpack_public_path__ + "static/middle2-7a16fd05e191709de4675abc338a3c56.png";